import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import VerticalBarChart from "../../../../ui/VerticalBarChart";
import Loader from "../../../../ui/Loader";
import { useFilters } from "../../../../contexts/FiltersContext";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";


const data = [
  { name: 'Write a blog about Water Shortage in Bengaluru', numberOfSubmissions: 42 },
  { name: 'Rainwater Harvesting', numberOfSubmissions: 38 },
  { name: 'Composting', numberOfSubmissions: 56 },
];

const COLORS = ['var(--barFirst-color)', 'var(--barSecond-color)', 'var(--barThird-color)'];

const ImpactCertificatesTab = ({projectId,imageGenerationTimestamp}) => {
  const { selectedPrimary, setFilterOptions } = useFilters()
  const { loading, response, error } = useFetchData(
    getProjectStatistics,
    [projectId,"BOUNTY_WISE_IMPACT_CERTIFICATE_ISSUED_COUNT",imageGenerationTimestamp,""],
    [projectId,"BOUNTY_WISE_IMPACT_CERTIFICATE_ISSUED_COUNT",imageGenerationTimestamp,""]
  );

  useEffect(()=>{
    if (!loading && response) {
      const list = response?.bountyWiseImpactCertificateIssuedCount?.map(i=>i?.title).filter(Boolean) || []
      setFilterOptions({ label: 'Activities', options: list })
    }
  },[loading, response, setFilterOptions])

  const transformedData = response?.bountyWiseImpactCertificateIssuedCount?.map(certificate=>
  {
    return {
      name:certificate?.title,
      value:certificate?.impactCertificatesIssued,
      key:certificate?._id
    }
  }
  )?.sort((a,b)=>b?.value - a?.value) || []
  
  const allSelected = !selectedPrimary?.length || selectedPrimary.includes('All')
  const filteredData = allSelected ? transformedData : transformedData.filter(d => selectedPrimary.includes(d.name))

  if (loading) return  <div className='w-full h-[23.9375rem] flex pt-11 justify-center '  ><Loader/></div> ;
    
  if(filteredData?.length === 0) return <div className="w-full h-[23.9375rem] flex items-center justify-center text-gray-500">No data available</div>; 

  return (
    <VerticalBarChart
      data={filteredData}
      xAxisLabel="Activities"
      yAxisLabel="Impact Certificates awarded"
      barSize={40}
      visibleBars={17}
      height={500}
      showReferenceLine={true}
      referenceLineValue={50}
      domain={[0, 100]}
 
      ticks={[0, 20, 40, 60, 80, 100]}
    />
  );
};

export default ImpactCertificatesTab;